import { useQuery } from '@tanstack/react-query';

import * as workflowService from 'services/workflow';

export const useWorkflowTemplateQuery = (props) => {
  const { entityType, ...restProps } = props;

  const query = useQuery({
    queryKey: ['workflow', 'template', entityType],
    queryFn: async ({ queryKey }) => {
      const entityType = queryKey[2];
      const response = await workflowService.getAllWorkflowTemplatesService({
        EntityType: entityType,
      });

      return response.data;
    },
    ...restProps,
  });

  return query;
};
